'use strict';

var Control = require('./Control.js');
var Option = require('./Option.js');
var OptionMulti = require('./multi-select/OptionMulti.js');
var ControlMulti = require('./multi-select/ControlMulti.js');

const Select = {
    Control: Control.SelectControl,
    ControlMulti: ControlMulti.SelectControlMulti,
    Option: Option.SelectOption,
    OptionMulti: OptionMulti.SelectOptionMulti,
};

exports.Select = Select;
//# sourceMappingURL=index.js.map
